import { ActionReducer } from '@ngrx/store';

import { SoapChronologyState } from './soap-chronology.model';
import { initialState, SEARCH_SOAP_CHRONOLOGY_RECORDS, GET_SOAP_CHRONOLOGY_RECORDS, RESET_SOAP_CHRONOLOGY_GRID_DATA, RESET_SOAP_CHRONOLOGY_RECORDS_TO_INITIAL_STATE } from './soap-chronology.constants';
import { CLEAR_ALL_STORES_STATE, CustomAction } from '../index-store.constants';

export function soapChronologyReducer(state: SoapChronologyState = initialState, action: CustomAction) {
    switch (action.type) {
        case SEARCH_SOAP_CHRONOLOGY_RECORDS:
            return {
                patientRecordsSearchFilterFields: action.payload,
                patientRecordsSearchGridData: state.patientRecordsSearchGridData
            };
        case GET_SOAP_CHRONOLOGY_RECORDS:
            return {
                patientRecordsSearchFilterFields: state.patientRecordsSearchFilterFields,
                patientRecordsSearchGridData: {
                    rowsPerPageOptions: state.patientRecordsSearchGridData.rowsPerPageOptions,
                    cols: state.patientRecordsSearchGridData.cols,
                    pageLinks: state.patientRecordsSearchGridData.pageLinks,
                    rows: action.payload.rows,
                    configuration: action.payload.configuration,
                    filterData: action.payload.filterData,
                    totalRecords: action.payload.totalRecords
                }
            };
        case RESET_SOAP_CHRONOLOGY_GRID_DATA:
            return {
                patientRecordsSearchFilterFields: state.patientRecordsSearchFilterFields,
                patientRecordsSearchGridData: initialState.patientRecordsSearchGridData
            };
        case RESET_SOAP_CHRONOLOGY_RECORDS_TO_INITIAL_STATE:
        case CLEAR_ALL_STORES_STATE:
            return {
                patientRecordsSearchFilterFields: initialState.patientRecordsSearchFilterFields,
                patientRecordsSearchGridData: initialState.patientRecordsSearchGridData
            };
        default:
            return state;
    }
}
